var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9980_32718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 18.834C1.66699 17.0659 2.36937 15.3702 3.61961 14.1199C4.86986 12.8697 6.56555 12.1673 8.33366 12.1673C10.1018 12.1673 11.7975 12.8697 13.0477 14.1199C14.2979 15.3702 15.0003 17.0659 15.0003 18.834H13.3337C13.3337 17.5079 12.8069 16.2361 11.8692 15.2984C10.9315 14.3608 9.65974 13.834 8.33366 13.834C7.00758 13.834 5.73581 14.3608 4.79813 15.2984C3.86044 16.2361 3.33366 17.5079 3.33366 18.834H1.66699ZM8.33366 11.334C5.57116 11.334 3.33366 9.09648 3.33366 6.33398C3.33366 3.57148 5.57116 1.33398 8.33366 1.33398C11.0962 1.33398 13.3337 3.57148 13.3337 6.33398C13.3337 9.09648 11.0962 11.334 8.33366 11.334ZM8.33366 9.66732C10.1753 9.66732 11.667 8.17565 11.667 6.33398C11.667 4.49232 10.1753 3.00065 8.33366 3.00065C6.49199 3.00065 5.00033 4.49232 5.00033 6.33398C5.00033 8.17565 6.49199 9.66732 8.33366 9.66732ZM15.237 12.7532C16.4081 13.2806 17.402 14.135 18.0991 15.2137C18.7963 16.2925 19.1671 17.5496 19.167 18.834H17.5003C17.5005 17.8706 17.2225 16.9277 16.6996 16.1186C16.1767 15.3095 15.4312 14.6687 14.5528 14.2732L15.2362 12.7532H15.237ZM14.6637 3.34482C15.5033 3.6909 16.2211 4.2786 16.7262 5.03334C17.2312 5.78809 17.5007 6.67585 17.5003 7.58398C17.5007 8.72759 17.0734 9.83001 16.3024 10.6747C15.5315 11.5193 14.4726 12.0452 13.3337 12.149V10.4715C13.9511 10.3831 14.5239 10.099 14.9681 9.66103C15.4122 9.22307 15.7042 8.65425 15.8013 8.0381C15.8983 7.42194 15.7953 6.7909 15.5073 6.23761C15.2193 5.68433 14.7615 5.23794 14.2012 4.96398L14.6637 3.34482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9980_32718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users-2.13b30fc1.svg";
export { ForwardRef as ReactComponent };